// Configurações centralizadas do aplicativo
export const APP_CONFIG = {
    storeName: process.env.REACT_APP_STORE_NAME || 'PluginStore',
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:4000/api',
    uploadsBaseUrl: (process.env.REACT_APP_API_BASE_URL || 'http://localhost:4000/api').replace(/\/api$/, ''),
    mercadoPagoPublicKey: process.env.REACT_APP_MERCADOPAGO_PUBLIC_KEY || '',
    discordInviteUrl: process.env.REACT_APP_DISCORD_INVITE_URL || 'https://discord.gg/SEU_CONVITE_AQUI',
};
